import styled from '@emotion/styled';
import { ReactComponent as Svg } from 'assets/ibm/show-data--cards.svg';

export const SIcon = styled(Svg)`
  transform-origin: center;
  transform: rotate(-90deg);
`;
